import React, { useCallback } from "react";
import { useState } from "react";
import "./App.css";
import { Form, Formik, Field } from "formik";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useNavigate, useSearchParams } from "react-router-dom";

const TITLE = "かんたん請求ソフト　新規契約（無料お試しセットのお申込み）";

const services = {
  soudanSien: [
    { key: "KEIKAKU_SOUDAN", name: "計画相談支援" },
    { key: "TIKI_IKOU", name: "地域移行支援" },
    { key: "TIKI_TEITYAKU", name: "地域定着支援" },
    { key: "SHOGAIJI_SODAN", name: "障害児相談支援" },
  ],
  seikatsuSien: [
    { key: "IDO", name: "移動支援" },
    { key: "NICCHU", name: "日中一時支援" },
    { key: "OTHER", name: "その他" },
  ],
  sonota: [
    { key: "HOME_HELP", name: "居宅介護" },
    { key: "JUHO", name: "重度訪問介護" },
    { key: "KOUDOU", name: "行動援護" },
    { key: "JUDO_HOUKATSU", name: "重度障害者等包括支援" },
    { key: "DOUKOU", name: "同行援護" },
    { key: "RYOYO", name: "療養介護" },
    { key: "SEIKATSU_KAIGO", name: "生活介護" },
    { key: "TANKI", name: "短期入所" },
    { key: "SHISETSU_NYUSHO", name: "施設入所支援" },
    { key: "KYODO", name: "共同生活援助" },
    { key: "SYUKUHAKU_JIRITSU_KUNREN", name: "宿泊型自立訓練" },
    { key: "JIKATSU", name: "自立生活援助" },
    { key: "KINOU_KUNREN", name: "自立訓練（機能訓練）" },
    { key: "SEIKATSU_KUNREN", name: "自立訓練（生活訓練）" },
    { key: "SYURO_IKOU", name: "就労移行支援" },
    { key: "SYURO_IKOU_YOUSEI", name: "就労移行支援（養成施設）" },
    { key: "SYUKEI_A", name: "就労継続支援A型" },
    { key: "SYUKEI_B", name: "就労継続支援B型" },
    { key: "TEITYAKU", name: "就労定着支援" },
    { key: "SYURO_SENTAKU", name: "就労選択支援" },
  ],
  jidou: [
    { key: "JIHATSU", name: "児童発達支援" },
    { key: "JIHATSU_CENTER_IRYO", name: "医療型児童発達支援" },
    { key: "HOKAGO", name: "放課後等デイサービス" },
    { key: "HOHO", name: "保育所等訪問支援" },
    { key: "JIHATSU_KYOTAKU", name: "居宅訪問型児童発達支援" },
    { key: "NYUSHO", name: "障害児入所支援" },
    { key: "NYUSHO_IRYO", name: "医療型障害児入所支援" },
  ],
};

const chances = [
  { key: 9, name: "ウェブで検索した" },
  { key: 3, name: "ダイレクトメールを見た" },
  { key: 8, name: "展示会を見た" },
  { key: 4, name: "チラシを見た" },
  { key: 5, name: "広告を見た" },
  { key: 6, name: "他の事業所に教えてもらった" },
  { key: 7, name: "その他" },
];

const nowsofts = [
  { key: 1, name: "新規開所" },
  { key: 2, name: "他社ソフト" },
  { key: 3, name: "国保連 簡易入力システム" },
  { key: 4, name: "税理士/行政書士などに委託" },
];

const client = axios.create({ baseURL: process.env.BASE_URL });

function Trial() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const facility = [];
  for (let i = 1; i <= 30; i++) {
    facility.push({
      no: i,
      facilityName: "",
      facilityNumber: "",
      serviceKey: "",
    });
  }
  const [errors, setErrors] = useState([]);
  const [customerInfoErrors, setCustomerInfoErrors] = useState([]);
  const [apiMessage, setApiMessage] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [address, setAddress] = useState("");
  const [tel, setTel] = useState("");
  const [email, setEmail] = useState("");
  const [person, setPerson] = useState("");
  const [chance, setChance] = useState("");
  const [otherFacility, setOtherFacility] = useState("");
  const [nowsoft, setNowsoft] = useState("");
  const [nowsoftname, setNowsoftname] = useState("");
  const [displayingFacilityCount, setDisplayingFacilityCount] = useState(5);
  const [isAcceptTerm, setIsAcceptTerm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    facility: facility,
  };

  const validates = (values) => {
    return values.facility.map((facility) => {
      if (
        (facility.facilityName.length > 0 &&
          facility.serviceKey.length === 0) ||
        (facility.facilityName.length === 0 && facility.serviceKey.length > 0)
      ) {
        // 事業所名とサービス種別の入力必須
        return `${facility.no}行目：事業所名またはサービス種別が入力されていません。`;
      } else if (
        facility.facilityName.length > 0 &&
        (/^[\s　]|["']|[\s　]$/g).test(facility.facilityNumber)
      ) {
        // 「"」「'」前後の空白は登録させない
        return `${facility.no}行目：事業所番号の「"」「'」又は前後の空白を取り除いて入力してください。`;
      } else if (facility.facilityNumber.length > 32) {
        // 32桁以内で入力
        return `${facility.no}行目：事業所番号は32文字以内で入力してください。`;
      } else if (
        facility.serviceKey !== "IDO" &&
        facility.serviceKey !== "NICCHU" &&
        facility.serviceKey !== "OTHER"
      ) {
        // 地域生活地域支援事業以外の場合
        if (
          facility.facilityName.length > 0 &&
          facility.facilityNumber.length !== 10
        ) {
          return `${facility.no}行目：事業所番号は10文字で入力してください。`;
        }
      }

      return null;
    });
  };

  const validateCustomerInfo = useCallback(() => {
    const errorMessages = [];
    if (companyName === "") {
      errorMessages["companyName"] = "法人名を入力してください。";
    } else if (companyName.length >= 256) {
      errorMessages["companyName"] = "法人名は255文字以内で入力してください。";
    }

    if (zipcode === "") {
      errorMessages["zipcode"] = "郵便番号を入力してください。";
    } else if (!zipcode.match(/^\d{7}$/)) {
      errorMessages["zipcode"] = "半角数値7文字で入力してください。";
    }

    if (address === "") {
      errorMessages["address"] = "住所を入力してください。";
    } else if (address.length >= 256) {
      errorMessages["address"] = "住所は255文字以内で入力してください。";
    }

    if (tel === "") {
      errorMessages["tel"] = "電話番号を入力してください。";
    } else if (tel.length >= 256) {
      errorMessages["tel"] = "電話番号は255文字以内で入力してください。";
    }

    if (email === "") {
      errorMessages["email"] = "メールアドレスを入力してください。";
    } else if (email.length >= 256) {
      errorMessages["email"] =
        "メールアドレスは255文字以内で入力してください。";
    }

    if (person === "") {
      errorMessages["person"] = "登録担当者を入力してください。";
    } else if (person.length >= 256) {
      errorMessages["person"] = "登録担当者は255文字以内で入力してください。";
    }

    if (chance === "") {
      errorMessages["chance"] =
        "「かんたん請求ソフト」をどのようにして知りましたか？を選択してください。";
    }

    if (otherFacility.length >= 256) {
      errorMessages["otherFacility"] =
        "他の事業所に教えてもらったときに、その名称は255文字以内で入力してください。";
    }

    if (nowsoft === "") {
      errorMessages["nowsoft"] = "現在お使いのソフトを選択してください。";
    }

    // 使っていたソフトが他社かつ、ソフト名が空
    if (nowsoft === "2" && nowsoftname === "") {
      errorMessages["nowsoftname"] = "ソフト名を入力してください。";
    } else if (nowsoft === "2" && nowsoftname.length >= 256) {
      errorMessages["nowsoftname"] =
        "ソフト名は255文字以内で入力してください。";
    }

    return errorMessages;
  }, [
    address,
    companyName,
    email,
    person,
    tel,
    zipcode,
    chance,
    nowsoft,
    nowsoftname,
    otherFacility.length,
  ]);

  const validFacilities = (values) => {
    return values.facility.filter((facility) => {
      return (
        facility.facilityName.length > 0 &&
        facility.serviceKey.length > 0 &&
        facility.facilityNumber.length <= 32
      );
    });
  };

  const onSubmit = (values) => {
    const errors = validates(values);
    setErrors(errors);
    if (errors.filter((e) => e).length > 0) {
      return;
    }

    let estimate = 0;
    const valid = validFacilities(values);
    if (valid.length === 0) {
      return;
    }

    // 2025年2月1日からの料金改定対応
    if (new Date() >= new Date("2025-02-01")) {
      // 相談支援事業 ¥10,980/事業所番号
      if (valid.some((v) => isSoudanSien(v))) {
        estimate += 10980;
      }
      // 地域生活支援事業 ¥5,980/事業所番号
      if (valid.some((v) => isSeikatsuSien(v))) {
        estimate += 5480;
      }
    } else {
      if (valid.some((v) => isSoudanSien(v))) {
        // 相談支援事業 ¥9,980/事業所番号
        estimate += 9980;
      }
      // 地域生活支援事業 ¥4,980/事業所番号
      if (valid.some((v) => isSeikatsuSien(v))) {
        estimate += 4980;
      }
    }

    // 「上記以外の事業 ¥9,980/事業所番号」計算
    const facilityNumbers = {};
    valid
      .filter((v) => !isSoudanSien(v))
      .filter((v) => !isSeikatsuSien(v))
      .forEach((v) => {
        facilityNumbers[v.facilityNumber] = v.serviceKey;
      });
    // 2025年2月1日からの料金改定対応
    if (new Date() >= new Date("2025-02-01")) {
      Object.values(facilityNumbers).forEach((v) => {
        if (isSonota(v)) {
          estimate += 10980;
        } else if (isJidou(v)) {
          estimate += 10800;
        }
      });
    } else {
      Object.values(facilityNumbers).forEach((v) => {
        if (isSonota(v)) {
          estimate += 9980;
        }
      });
    }
    const willSubmitParams = valid.map((v) => ({
      facilityName: v.facilityName,
      facilityNumber: v.facilityNumber,
      serviceKey: v.serviceKey,
    }));

    onRegister(estimate, willSubmitParams);
  };

  const getAddress = (zipcode) => {
    axios
      .get(`${process.env.REACT_APP_ZIPCODE_API_URL}?zipcode=${zipcode}`)
      .then((res) => {
        if (res.data.status !== 200 || res.data.results == null) {
          if (res.data.message == null) {
            setApiMessage("住所を取得できません。");
            return;
          }
          setApiMessage(res.data.message);
          return;
        }

        setApiMessage(null);
        const address = `${res.data.results[0]["address1"]}${res.data.results[0]["address2"]}${res.data.results[0]["address3"]}`;
        setAddress(address);
      })
      .catch((error) => {
        setApiMessage(error);
      });
  };

  const convertToHalfZip = (value) => {
    // 半角数字以外を削除
    const convertedZip = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });
    const replacedZipcode = convertedZip.replace(/[^\d]+/g, "");

    setZipcode(replacedZipcode);
  };

  const convertToHalfTel = (value) => {
    const convertedTel = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });

    setTel(convertedTel);
  };

  const isSoudanSien = (facility) => {
    return services.soudanSien.map((s) => s.key).includes(facility.serviceKey);
  };

  const isSeikatsuSien = (facility) => {
    return services.seikatsuSien
      .map((s) => s.key)
      .includes(facility.serviceKey);
  };

  const isSonota = (serviceKey) => {
    return services.sonota.map((s) => s.key).includes(serviceKey);
  };

  const isJidou = (serviceKey) => {
    return services.jidou.map((s) => s.key).includes(serviceKey);
  };

  const onChange = (e, setFieldValue) => {
    setFieldValue(e.target.name, e.target.value);
  };

  const postApplyFacilities = useCallback(
    async (customerNumber, willSubmitParams) => {
      await client
        .post(`/public/temp/customers/${customerNumber}/facilities`, {
          facilities: willSubmitParams,
        })
        .then((res) => {
          navigate("/trial/result", {
            state: {
              title: TITLE,
              message: `登録が完了しました。\n\nお申し込みいただき誠にありがとうございます。\n説明書とお客様番号を数日中にお送りさせていただきます。\nまた、ご登録いただいたメールアドレス宛にオーナーアカウント発行手続きのメールをご案内させていただきます。\nお手数おかけしますが、ご対応のほど何卒よろしくお願い申し上げます。\nお客様相談窓口　0120-76-7299`,
            },
          });
        })
        .catch((error) => {
          setApiMessage(error.response.body.error.message);
        });
    },
    [navigate]
  );

  const postApplyConsent = useCallback(
    async (customerNumber, estimate, willSubmitParams) => {
      const priceText = estimate.toLocaleString();
      await client
        .post(`/public/temp/customers/${customerNumber}/consent`, {
          kind: "4",
          priceText: priceText,
        })
        .then((res) => {
          postApplyFacilities(customerNumber, willSubmitParams);
        })
        .catch((error) => {
          setApiMessage(error.response.body.error.message);
        });
    },
    [postApplyFacilities]
  );

  const postCustomerInfo = useCallback(
    async (estimate, willSubmitParams) => {
      const params = new URLSearchParams();
      params.append("jigyousha", companyName);
      params.append("zipcode", zipcode);
      params.append("address", address);
      params.append("tel", tel);
      params.append("person", person);
      params.append("mailaddress", email);
      params.append("from", chance);
      params.append("oshiete_jigyousha", otherFacility);
      params.append("nowsoft", nowsoft);
      params.append("nowsoftname", nowsoftname);
      params.append("appform", "4");
      params.append("insert", "true");
      params.append("page", "2");
      params.append("plan3", "1");
      params.append("lead_id", searchParams.get("lead_id") ?? "");
      params.append("contact_id", searchParams.get("contact_id") ?? "");
      params.append("service", searchParams.get("service") ?? "");
      params.append("utm_source", searchParams.get("utm_source") ?? "");
      params.append("lp_category", searchParams.get("lp_category") ?? "");
      params.append("content", searchParams.get("content") ?? "");
      params.append("utm_campaign", searchParams.get("utm_campaign") ?? "");
      params.append("utm_term", searchParams.get("utm_term") ?? "");

      await client
        .post(`/public/temp/customers/regist-renewal`, params)
        .then((res) => {
          postApplyConsent(res.data.username, estimate, willSubmitParams);
        })
        .catch((error) => {
          if (error.response?.data?.error?.mailaddress) {
            navigate("/trial/mail-error", {
              state: {
                title: TITLE
              },
            });
          } else {
            navigate("/trial/result", {
              state: {
                title: TITLE,
                message: `エラーが発生しました。時間をおいて再度操作してください。`,
              },
            });
          }
        });
    },
    [
      companyName,
      address,
      email,
      person,
      tel,
      zipcode,
      navigate,
      chance,
      nowsoft,
      nowsoftname,
      otherFacility,
      postApplyConsent,
      searchParams,
    ]
  );

  const onRegister = useCallback(
    (estimate, willSubmitParams) => {
      const customerInfoErrors = validateCustomerInfo();
      if (Object.keys(customerInfoErrors).length > 0) {
        setCustomerInfoErrors(customerInfoErrors);
        return;
      }
      setIsLoading(true);
      postCustomerInfo(estimate, willSubmitParams);
    },
    [validateCustomerInfo, postCustomerInfo]
  );

  const handleBlurFacilityNumber = (e, setFieldValue) => {
    const halfNumber = e.target.value.replace(/[０-９]/g, (s) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    );
    setFieldValue(e.target.name, halfNumber);
  };

  const handleClickAddFacilitiesIcon = () => {
    setDisplayingFacilityCount((prevState) => prevState + 5);
  };

  const handleChangeIsAcceptTerm = () => {
    setIsAcceptTerm((prevState) => !prevState);
  };

  function SelectServiceList() {
    // 2025年2月1日以降の場合にのみ表示
    if (new Date() >= new Date("2025-02-01")) {
      return (
        <optgroup label="児童福祉サービス事業">
          {services.jidou.map((service) => {
            return (
              <option key={service.key} value={service.key}>
                {service.name}
              </option>
            );
          })}
        </optgroup>
      );
    } else{
      return null;
    }
  }

  return (
    <div>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="trial-form-header">
        <img
          className="logo"
          src={`${process.env.PUBLIC_URL}/kantan_seikyu_logo.png`}
          alt={TITLE}
        />
      </div>

      <div className="trial-form-main-background">
        <div className="trial-form-main">
          <div className="trial-form-title-area">
            <h2 className="trial-form-title">無料お試しセットのお申込み</h2>
            <div className="trial-form-title-note">
              <p>かんたん請求ソフトを60日間お試し。</p>
              <p>
                60日を過ぎても自動的に加入申し込みにはなりません。料金も勝手に発生しませんのでご安心ください。
              </p>
              <p>１分程度で回答できます。</p>
            </div>
          </div>

          <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {({ values, setFieldValue }) => {
              return (
                <Form>
                  <Errors errors={Object.values(customerInfoErrors)} />
                  <Errors errors={errors} />
                  {apiMessage && (
                    <div className="api-message">
                      <p>{apiMessage}</p>
                    </div>
                  )}
                  <div className="trial-form-wrapper">
                    <div className="trial-form">
                      <div className="form-item">
                        <div className="label">法人名</div>
                        <div className="required">必須</div>
                        <Field
                          onChange={(e) => setCompanyName(e.target.value)}
                          placeholder="株式会社LITALICO"
                          name="companyName"
                          className={`text-field ${
                            customerInfoErrors["companyName"]
                              ? "error-border"
                              : ""
                          }`}
                        />
                      </div>
                      <div className="form-item">
                        <div className="label">郵便番号</div>
                        <div className="required">必須</div>
                        <Field
                          onBlur={(e) => convertToHalfZip(e.target.value)}
                          onChange={(e) => setZipcode(e.target.value)}
                          placeholder="1234567"
                          name="zipcode"
                          className={`text-field ${
                            customerInfoErrors["zipcode"] ? "error-border" : ""
                          }`}
                        />
                        <button
                          className="button"
                          onClick={() => getAddress(zipcode)}
                          type="button"
                        >
                          住所表示
                        </button>
                      </div>
                      <div className="form-item">
                        <div className="label">住所</div>
                        <div className="required">必須</div>
                        <Field
                          onChange={(e) => setAddress(e.target.value)}
                          placeholder="長崎県佐世保市万徳町1-20"
                          name="address"
                          className={`text-field ${
                            customerInfoErrors["address"] ? "error-border" : ""
                          }`}
                          value={address}
                        />
                      </div>
                      <div className="form-item">
                        <div className="label">
                          電話番号
                          <span className="label-note">
                            ※日中ご連絡がとれるお電話番号をご入力ください。
                          </span>
                        </div>
                        <div className="required">必須</div>
                        <Field
                          onBlur={(e) => convertToHalfTel(e.target.value)}
                          onChange={(e) => setTel(e.target.value)}
                          placeholder="0312345678"
                          name="tel"
                          className={`text-field ${
                            customerInfoErrors["tel"] ? "error-border" : ""
                          }`}
                        />
                      </div>
                      <div className="form-item">
                        <div className="label">メールアドレス</div>
                        <div className="required">必須</div>
                        <Field
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="taro@litalico.co.jp"
                          name="email"
                          className={`text-field ${
                            customerInfoErrors["email"] ? "error-border" : ""
                          }`}
                        />
                      </div>
                      <div className="form-item">
                        <div className="label">登録担当者</div>
                        <div className="required">必須</div>
                        <Field
                          onChange={(e) => setPerson(e.target.value)}
                          placeholder="福祉太郎"
                          name="person"
                          className={`text-field ${
                            customerInfoErrors["person"] ? "error-border" : ""
                          }`}
                        />
                      </div>
                      <div className="form-item">
                        <div className="label">
                          かんたん請求ソフトをどのようにして知りましたか？
                        </div>
                        <div className="required">必須</div>
                        <div className="field-column">
                          <div className="field-column-item">
                            <Field
                              onChange={(e) => setChance(e.target.value)}
                              as="select"
                              name="chance"
                              className={`select-field ${
                                customerInfoErrors["chance"]
                                  ? "error-border"
                                  : ""
                              }`}
                            >
                              <option value="">ここから選択してください</option>
                              {chances.map((chance) => {
                                return (
                                  <option key={chance.key} value={chance.key}>
                                    {chance.name}
                                  </option>
                                );
                              })}
                            </Field>
                          </div>
                          {chance === "6" && (
                            <div className="field-column-item">
                              <div className="added-field-label">
                                教えてもらった事業所名を入力してください
                              </div>
                              <Field
                                onChange={(e) =>
                                  setOtherFacility(e.target.value)
                                }
                                placeholder="abc事業所"
                                name="otherFacility"
                                className={`text-field ${
                                  customerInfoErrors["otherFacility"]
                                    ? "error-border"
                                    : ""
                                }`}
                                disabled={chance !== "6"}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="form-item">
                        <div className="label">現在の請求方法</div>
                        <div className="required">必須</div>
                        <div className="field-column">
                          <div className="field-column-item">
                            <Field
                              onChange={(e) => setNowsoft(e.target.value)}
                              as="select"
                              name="nowsoft"
                              className={`select-field ${
                                nowsoft === "" && customerInfoErrors["nowsoft"]
                                  ? "error-border"
                                  : ""
                              }`}
                            >
                              <option value="">ここから選択してください</option>
                              {nowsofts.map((nowsoft) => {
                                return (
                                  <option key={nowsoft.key} value={nowsoft.key}>
                                    {nowsoft.name}
                                  </option>
                                );
                              })}
                            </Field>
                          </div>
                          {nowsoft === "2" && (
                            <div className="field-column-item">
                              <div className="added-field-label">
                                お使いのソフト名を入力してください
                              </div>
                              <Field
                                onChange={(e) => setNowsoftname(e.target.value)}
                                placeholder="abcソフト"
                                name="nowsoftname"
                                className={`text-field ${
                                  customerInfoErrors["nowsoftname"]
                                    ? "error-border"
                                    : ""
                                }`}
                                disabled={nowsoft !== "2"}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="form-item">
                        <div className="emphasis-title">
                          <span className="title-text">登録したい事業所</span>
                          <span className="required">必須</span>
                        </div>
                        {values.facility
                          .slice(0, displayingFacilityCount)
                          .map((facility, i) => {
                            return (
                              <div
                                key={facility.no}
                                className="trial-form-facility-card visible-only-not-desktop"
                              >
                                <div className="facility-number">
                                  {facility.no}
                                </div>
                                <div className="field-label">事業所名</div>
                                <div className="field-wrapper">
                                  <Field
                                    onChange={(e) => onChange(e, setFieldValue)}
                                    name={`facility[${i}].facilityName`}
                                    placeholder="事業所名を入力してください"
                                    className={`text-field ${
                                      facility.facilityName.length === 0 &&
                                      errors[i]
                                        ? "error-border"
                                        : ""
                                    }`}
                                  />
                                </div>
                                <div className="field-label">事業所番号</div>
                                <div className="field-wrapper">
                                  <Field
                                    onBlur={(e) =>
                                      handleBlurFacilityNumber(e, setFieldValue)
                                    }
                                    name={`facility[${i}].facilityNumber`}
                                    className={`text-field ${
                                      facility.facilityNumber.length > 32 &&
                                      errors[i]
                                        ? "error-border"
                                        : ""
                                    }`}
                                    placeholder="事業所番号を入力してください"
                                  />
                                </div>
                                <div className="field-label">サービス種別</div>
                                <div className="field-wrapper">
                                  <Field
                                    onChange={(e) => onChange(e, setFieldValue)}
                                    as="select"
                                    name={`facility[${i}].serviceKey`}
                                    className={`select-field ${
                                      facility.serviceKey.length === 0 &&
                                      errors[i]
                                        ? "error-border"
                                        : ""
                                    }`}
                                  >
                                    <option value="">
                                      サービス種別を選択してください
                                    </option>
                                    <optgroup label="相談支援事業">
                                      {services.soudanSien.map((service) => {
                                        return (
                                          <option
                                            key={service.key}
                                            value={service.key}
                                          >
                                            {service.name}
                                          </option>
                                        );
                                      })}
                                    </optgroup>
                                    <optgroup label="地域生活支援事業">
                                      {services.seikatsuSien.map((service) => {
                                        return (
                                          <option
                                            key={service.key}
                                            value={service.key}
                                          >
                                            {service.name}
                                          </option>
                                        );
                                      })}
                                    </optgroup>
                                    <SelectServiceList />
                                    <optgroup label="その他障害福祉サービス事業">
                                      {services.sonota.map((service) => {
                                        return (
                                          <option
                                            key={service.key}
                                            value={service.key}
                                          >
                                            {service.name}
                                          </option>
                                        );
                                      })}
                                    </optgroup>
                                  </Field>
                                </div>
                              </div>
                            );
                          })}
                        <table className="trial-form-facility-table visible-only-desktop">
                          <thead>
                            <tr>
                              <th className="row-number">No.</th>
                              <th className="facility-name">事業所名</th>
                              <th className="facility-number">事業所番号</th>
                              <th className="service">サービス種別</th>
                            </tr>
                          </thead>
                          <tbody>
                            {values.facility
                              .slice(0, displayingFacilityCount)
                              .map((facility, i) => {
                                return (
                                  <tr key={facility.no}>
                                    <td className="row-number-td">
                                      {facility.no}
                                    </td>
                                    <td>
                                      <Field
                                        onChange={(e) =>
                                          onChange(e, setFieldValue)
                                        }
                                        name={`facility[${i}].facilityName`}
                                        placeholder="事業所名を入力してください"
                                        className={
                                          facility.facilityName.length === 0 &&
                                          errors[i]
                                            ? "error-border"
                                            : ""
                                        }
                                      />
                                    </td>
                                    <td>
                                      <Field
                                        onBlur={(e) =>
                                          handleBlurFacilityNumber(
                                            e,
                                            setFieldValue
                                          )
                                        }
                                        name={`facility[${i}].facilityNumber`}
                                        className={
                                          facility.facilityNumber.length > 32 &&
                                          errors[i]
                                            ? "error-border"
                                            : ""
                                        }
                                        placeholder="事業所番号を入力してください"
                                      />
                                    </td>
                                    <td>
                                      <Field
                                        onChange={(e) =>
                                          onChange(e, setFieldValue)
                                        }
                                        as="select"
                                        name={`facility[${i}].serviceKey`}
                                        className={
                                          facility.serviceKey.length === 0 &&
                                          errors[i]
                                            ? "error-border"
                                            : ""
                                        }
                                      >
                                        <option value="">
                                          サービス種別を選択してください
                                        </option>
                                        <optgroup label="相談支援事業">
                                          {services.soudanSien.map(
                                            (service) => {
                                              return (
                                                <option
                                                  key={service.key}
                                                  value={service.key}
                                                >
                                                  {service.name}
                                                </option>
                                              );
                                            }
                                          )}
                                        </optgroup>
                                        <optgroup label="地域生活支援事業">
                                          {services.seikatsuSien.map(
                                            (service) => {
                                              return (
                                                <option
                                                  key={service.key}
                                                  value={service.key}
                                                >
                                                  {service.name}
                                                </option>
                                              );
                                            }
                                          )}
                                        </optgroup>
                                        <SelectServiceList />
                                        <optgroup label="その他障害福祉サービス事業">
                                          {services.sonota.map((service) => {
                                            return (
                                              <option
                                                key={service.key}
                                                value={service.key}
                                              >
                                                {service.name}
                                              </option>
                                            );
                                          })}
                                        </optgroup>
                                      </Field>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                        <div
                          className="add-facilities"
                          onClick={handleClickAddFacilitiesIcon}
                        >
                          <span className="circle-plus-icon">+</span>
                          <span className="add-facilities-text">
                            事業所を追加する（最大30事業所まで登録できます）
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="trial-form-conversion">
                    <div className="rule-links">
                      <a
                        className="link"
                        href="https://biz-form.snabi.jp/wps/seikyu_kiyaku.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        利用規約
                      </a>
                      <span className="separator"></span>
                      <a
                        className="link"
                        href="https://litalico.co.jp/policy/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        プライバシーポリシー
                      </a>
                    </div>
                    <div className="note">
                      <Field
                        checked={isAcceptTerm}
                        id="isAcceptTerm"
                        name="isAcceptTerm"
                        onChange={handleChangeIsAcceptTerm}
                        type="checkbox"
                        value={isAcceptTerm}
                      />
                      <label htmlFor="isAcceptTerm">
                        <span>
                          上記申込みにあたり、利用規約およびプライバシーポリシーを確認し、同意しました。
                        </span>
                      </label>
                    </div>
                    <button
                      className="button"
                      disabled={
                        validFacilities(values).length === 0 ||
                        !isAcceptTerm ||
                        isLoading
                      }
                      type="submit"
                    >
                      上記に同意して申し込む
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default Trial;

function Errors(props) {
  return (
    <div>
      {props.errors
        .filter((e) => e)
        .map((error, i) => {
          return (
            <div className="message" key={i}>
              <p>{error}</p>
            </div>
          );
        })}
    </div>
  );
}

